import React, { useEffect } from "react";
import Hero from "@/components/landing/Hero";
import SectionHeader from "@/components/landing/SectionHeader";
import PrimaryCards from "@/components/landing/PrimaryCards";
import Pricing from "@/components/landing/Pricing";
import PitchMeeting from "@/components/landing/PitchMeeting";
import FounderQuote from "@/components/landing/FounderQuote";
import SiteFooter from "@/components/landing/SiteFooter";

const LandingPage = () => {
  // Reveal-on-scroll for elements with .reveal — purely additive editorial polish.
  useEffect(() => {
    const els = document.querySelectorAll(".reveal:not(.is-visible)");
    if (!els.length || typeof IntersectionObserver === "undefined") {
      els.forEach((el) => el.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <main data-testid="landing-page" className="bg-cream">
      <Hero />
      <SectionHeader />
      <PrimaryCards />
      <Pricing />
      <PitchMeeting />
      <FounderQuote />
      <SiteFooter />
    </main>
  );
};

export default LandingPage;
